// extracted by mini-css-extract-plugin
export default {"confirmMessage":"sentCard_confirmMessage__xlCgc","confirmWrapper":"sentCard_confirmWrapper__G3NIy"};